exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Gifts__root___21fDn {\n  max-width: 920px;\n  padding: 0 16px;\n}\n\n.Gifts__paypalButton___3l5vA {\n  background: #ffc439;\n  -ms-flex-item-align: center;\n      align-self: center;\n  padding: 0 32px;\n  margin: 24px 0;\n}\n\n.Gifts__paypalButton___3l5vA img {\n  height: 50%;\n}\n\n.Gifts__paypalButton___3l5vA:hover {\n  background: rgb(238, 173, 42) !important;\n}\n\n.Gifts__disclaimer___1EhW2 {\n  font-size: 12px;\n  line-height: 14px;\n  font-style: italic;\n  text-align: center;\n  width: 80%;\n  -ms-flex-item-align: center;\n      align-self: center;\n}\n", ""]);

// exports
exports.locals = {
	"root": "Gifts__root___21fDn",
	"paypalButton": "Gifts__paypalButton___3l5vA",
	"disclaimer": "Gifts__disclaimer___1EhW2"
};